//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'folio',
        value: 'invoice_number',
    },
    {
        text: 'rut',
        value: 'pch_provider_rut',
        format: 'rut',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_business_name',
    },
    {
        text: 'monto',
        value: 'total',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'vencimiento',
        value: 'pch_provider_debt_to_pay_date_to_pay',
        align: 'right',
        format: 'date',
    },
    {
        text: 'estado',
        value: 'state',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                colors: {
                    atrasado: 'error lighten-3',
                    por_pagar: 'accent lighten-3',
                },
                small: true,
            },
        },
    },
    {
        text: 'pagable',
        value: 'payable',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
    {
        text: 'modificación',
        value: 'updated_at',
        align: 'right',
        format: 'datetime',
    },
]
